module.exports = __webpack_public_path__ + "img/workplay-12.35d56135.jpg";